export default __webpack_public_path__ + "static/media/payment-success-woman-mobile.1f0a3173.webp";